import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import withCurrencyConfig from '../../config/WithCurrencyConfig';
import { mParticleSelectPlacements, canUseMParticle, mParticleLogPageView } from './RoktMParticle';
import { addReservationCompleteHook, addStateTransitionHook, addGoToCheckoutHook } from '../../actions/hooks';

class Rokt extends Component {
  confirmationInitialized = false;
  roktLauncher = null;
  placementSelection = null;
  pagesLogged = [];

  componentDidMount() {
    this.props.addReservationCompleteHook(this.onReservationComplete);
    this.props.addStateTransitionHook(this.onStateTransition);
    this.props.addGoToCheckoutHook(this.onGoToCheckout);
    this.logPageView('home'); // log the page load
  }

  componentDidUpdate() {
    const routeHash = window.location.hash;
    if (!routeHash.includes('confirmation')) {
      return;
    }

    const canRunNewSdk = canUseMParticle();
    const canRunOldSdk = this.props.data?.accountId;

    if (this.props.data?.attributes && (canRunNewSdk || canRunOldSdk)) {
      if (this.confirmationInitialized) {
        return;
      } else {
        this.confirmationInitialized = true;
      }
      if (canRunNewSdk) {
        this.showConfirmationPlacementV2();
      } else {
        this.showConfirmationPlacementV1();
      }
    }
  }

  componentWillUnmount() {
    this.roktLauncher?.terminate?.();
    this.placementSelection?.close();
  }

  onReservationComplete = () => {
    // reset if order completed
    this.pagesLogged = [];
  }

  onStateTransition = page => {
    this.logPageView(page);
  }

  onGoToCheckout = () => {
    this.logPageView('checkout');
  }

  logPageView = page => {
    if (!this.pagesLogged.includes(page)) {
      this.pagesLogged = [...this.pagesLogged, page];
      mParticleLogPageView(page);
    }
  }

  showConfirmationPlacementV1() {
    const { accountId, sandbox, identifier } = this.props.data;
    const roktLauncherElement = document.getElementById('rokt-launcher');

    return new Promise((resolve, reject) => {
      if (window.Rokt) {
        resolve();
      } else if (roktLauncherElement) {
        roktLauncherElement.onload = resolve;
      } else {
        reject("Rokt Launcher hasn't been added to the DOM. User has opted out from analytics.");
      }
    })
      .then(() =>
        window.Rokt.createLauncher({
          accountId,
          sandbox,
        }),
      )
      .then((launcherInstance) => {
        this.roktLauncher = launcherInstance;

        return this.roktLauncher.selectPlacements({
          identifier: identifier,
          attributes: { ...this.props.data.attributes },
        });
      })
      .catch((e) => {
        if (sandbox) {
          console.error(e);
        }
      });
  }

  showConfirmationPlacementV2 = async () => {
    const { identifier } = this.props.data;
    this.placementSelection = await mParticleSelectPlacements(identifier, { ...this.props.data.attributes });
  }

  render() {
    return null;
  }
}

const mapStateToProps = (state) => {
  return {
    data: state?.confirmation?.roktPayload,
  };
};

const mapDispatchToProps = dispatch => {
    return bindActionCreators({
        addReservationCompleteHook,
        addStateTransitionHook,
        addGoToCheckoutHook,
    }, dispatch);
}

export const RoktPlaceholder = () => <div id="rokt-placeholder" className="rokt-placeholder" />;

export default withCurrencyConfig(connect(mapStateToProps, mapDispatchToProps)(Rokt));
